export const persistirSeleccion = (clave, lista, onSeleccion) => {
  try {
    localStorage.setItem(clave, JSON.stringify(lista));
  } catch (e) {
    console.error("Error guardando", clave, e);
  }
  if (typeof onSeleccion === "function") {
    onSeleccion(lista);
  }
};

export const reemplazarProducto = (lista = [], producto) => {
  const existe = lista.some((p) => p.id === producto.id);
  if (existe) return lista.map((p) => (p.id === producto.id ? producto : p));
  return [producto, ...lista];
};
